import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Bbox } from '@/types/types';

const initialState = {
    drawingId: 0,
    bboxes: [] as Bbox[],
    scheduleId: 0,
    generateNotes: false,
    tagIds: [] as number[],
    checks: [] as string[]
}

const scheduleChecksGeneratorSlice = createSlice({
    name: 'scheduleChecks',
    initialState: initialState,
    reducers: {
        bboxingStarted: (state, action: PayloadAction<number>) => {
            state.drawingId = action.payload;
        },

        bboxAdded: (state, action: PayloadAction<Bbox>) => {
            state.bboxes.push(action.payload);
        },

        scheduleNotesSet: (state, action: PayloadAction<number>) => {
            state.scheduleId = action.payload;
            state.generateNotes = true;
            state.tagIds = [];
        },

        scheduleTagsSet: (state, action: PayloadAction<number[]>) => {
            state.generateNotes = false;
            state.tagIds = action.payload;
        },

        bboxingReset: () => initialState,

        checksSet:(state, action: PayloadAction<string[]>) => {
            state.checks = action.payload;
        },
    }
})

export const { bboxingStarted, bboxAdded, scheduleNotesSet, scheduleTagsSet, bboxingReset, checksSet } = scheduleChecksGeneratorSlice.actions;
export default scheduleChecksGeneratorSlice.reducer; 
